import { createFileRoute } from "@tanstack/react-router";
import { TenantNodeGroupsPage } from "@/features/tenant/NodeGroupsPage";

export const Route = createFileRoute("/app/tenant/node-groups")({ component: TenantNodeGroupsPage });
